const messages = {
  dashboard: {
    title: "Field Service Dashboard",
    description:
      "Welcome to your dashboard. Here you can view current figures and participating companies from your customer base.",
    overview: {
      title: "Overview of participating customers",
      description:
        'Companies that have registered with BRIDGESTONE <span class="text-danger">PLUS</span> and that we can assign to you via the customer number.',
      month: "New this month",
      year: "New this year",
      all: "Total",
    },
    credits: {
      title: "Points credits",
      description:
        "Reward points credited to participating companies based on the submitted sales figures.",
      month: "Last month",
      year: "Current year",
      prev_year: "Total",
      allDealers: "All dealer points",
      allPoints: "All points",
      prev_month: "Previous month",
    },
    details: {
      title: "Participating customers in detail",
      description:
        'Below are the companies that have registered with a Bridgestone customer number on BRIDGESTONE <span class="text-danger">PLUS</span> and that are assigned to you as the responsible person. Use the sorting functions for a different order or the search form.<br/><br/> <b>Note:</b> Clicking on the points balance takes you to the detailed account statement.',
    },
    lastImport:
      'Last import of sales figures: <br/> <span class="text-danger">{date}</span>',
    kickback: {
      description:
        "Kickback fees are credited to participating companies based on the submitted sales figures.",
    },
    tyres: {
      title: "Tyres",
      description: "Tyres purchased by programme participants",
    },
    short:
      "Welcome to your dashboard. Here you can view current figures and participating companies from your customer base.",
    headers: {
      city: "City",
      company: "Company",
      current_points: "current points",
      customer_number: "customer number",
      details: "details",
      last_login: "Last login",
      name: "name",
      postal_code: "Postal code",
      street: "street",
      email: "Email",
    },
    reload: "Reload",
    exports: {
      title: "Exported Excel files",
      downloadExcel: "Download Excel",
      running: "Running",
      head: {
        name: "Name",
        status: "Status",
      },
    },
  },
};
export default {
  messages,
};
